import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as DNAIcon } from '../assets/icons/dna-icon.svg';
import SmallBanner from '../components/smallBanner';
import { ReactComponent as ExploreArrow } from '../assets/icons/double-arrow.svg';
import axios from "axios";
import Service01 from '../assets/Images/service-01.png';
import { BASE_URL, GET_PRODUCT_TYPE } from "../ApiUrl";

const OurProducts = () => {


    const [product, setProduct] = useState([]);
    const navigate = useNavigate();

    const fetchProduct = async () => {
        try {
            const result = await axios.get(BASE_URL + GET_PRODUCT_TYPE);
            setProduct(result.data.productTypes);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    };

    // console.log(product, "productproduct");


    useEffect(() => {
        fetchProduct();
    }, []);

    const handleviewproduct = (item) => {
        navigate('/product-view', {
            state: { item }
        });
    };
    return (
        <main className="our-products-page" >
            <SmallBanner Heading={'Our Products'} />
            <section className="py-100 pb-5">
                <div className="container">
                    <div className="row justify-content-center" data-aos="fade-up" data-aos-duration="3000">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Our products</div>
                            <h2 className='section-title my-sm-2 my-0'>Discover High-Quality Health & Wellness Products</h2>
                        </div>
                    </div>
                </div>
            </section>

            <section className="our-services-wrapper">
                <div className="container">

                    <div className="row align-items-center pb-5">
                        <div className="col-lg-6 order-lg-0 order-1 mt-lg-0 mt-4" data-aos="fade-right" data-aos-duration="3000">
                            <img src={Service01} alt="pharmaceutical" className="globe-img" />
                        </div>
                        <div className="col-lg-6">
                            <p className='para-text my-3 col-md-10 text-lg-strat text-center mx-lg-0 mx-auto'>Looking for pharmaceuticals, nutraceuticals, veterinary products, or Ayurvedic solutions? At Avna Pvt Ltd, we offer a wide range of trusted, globally certified healthcare products to meet your needs.</p>
                            <ul className="ps-0 text-lg-start text-center">
                                <li className="mb-3">✅ <strong>Pharmaceuticals</strong> - Prescription & OTC Medicines </li>
                                <li className="mb-3">✅ <strong>Nutraceuticals</strong> - Vitamins, Supplements & Functional Foods </li>
                                <li className="mb-3">✅ <strong>Veterinary Products</strong> - Animal Healthcare & Nutritional Support</li>
                                <li className="mb-3">✅ <strong>Ayurvedic & Herbal</strong> - Natural Remedies for Holistic Wellness</li>
                                <li className="mb-3">✅ <strong>Cosmeceuticals & Skincare</strong> - Dermatology & Beauty Care</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="our-products-wrapper" data-aos="fade-in" data-aos-duration="3000">
                <div className="container">
                    <div className="row">
                        {product && product.length > 0 ? product.map((item, index) => {
                            return (
                                <div className="col-xl-4 col-md-6 col-sm-12 my-sm-3 my-2" key={index} onClick={() => handleviewproduct(item)}>
                                    <div className="product-box" >
                                        <div className="img-wrapper">
                                            <img src={BASE_URL + item.image} alt={item.image} className="pro-icon" />
                                        </div>
                                        <div className="right-wrapper">
                                            <h3 className="pro-title">{item.typename}</h3>
                                            <span className="pro-link" onClick={() => handleviewproduct(item)}>Learn More <ExploreArrow className="icon" /> </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        }) : (
                            <div>
                                <p className="text-center">No Product  available</p>
                            </div>
                        )}
                        <div className="col-12 text-center">
                            <Link to="/contact" className="btn-grad d-inline-block mx-auto w-auto">
                                View Our Full Product Catalog
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="cta-wrapper">
                <div className="container">
                    <div className="row py-100 pb-0 justify-content-center">
                        <div className="col-lg-10 ">
                            <div className="cta-box text-center">
                                <h2 className="section-title text-white col-md-8 mx-auto">Can’t find what you’re looking for</h2>
                                <p className="para-text my-3  text-white">Contact us for custom formulations, private labeling, and bulk orders!
                                </p>
                                <Link to="/contact" className="mt-4 btn-grad d-inline-block mx-auto w-auto">
                                    Contact us
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main >
    );
};

export default OurProducts;

